import { render } from "./InternalRegulations.vue?vue&type=template&id=20b1d5a1"
import script from "./InternalRegulations.vue?vue&type=script&lang=js"
export * from "./InternalRegulations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__